import React from 'react'
import GradientBg from './gradient'
import logoFooter from "../icon/logoFooter.svg"

const Footer = () => {
  return (
    <section className='footer-section'>

      <div className='div-footer'>
        <div className='logo-footer-st'>
          <img src={logoFooter} alt='sodexs logo' />
          <div className='title-footer'>Space To Speed up</div>
        </div>
        <div className='description-footer'>© 2025 SCL. All rights reserved.</div>
      </div>

      <div className="bg-parent-contro-footer">
        <GradientBg />
      </div>
    </section>
  )
}

export default Footer